import { render, staticRenderFns } from "./EditProfileAction.vue?vue&type=template&id=729fb24c"
import script from "./EditProfileAction.vue?vue&type=script&lang=js"
export * from "./EditProfileAction.vue?vue&type=script&lang=js"
import style0 from "./EditProfileAction.vue?vue&type=style&index=0&id=729fb24c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports